import { AppError } from './AppError';

export class AuthError extends AppError {
    constructor(originalError: unknown, message: string) {
        super('AuthError', originalError, message);
    }
}

export const createAuthError = (originalError: unknown, message = `Failed to authenticate`) =>
    new AuthError(originalError, message);
